<template>
  <v-col cols="12" md=12 class="px-0">
    <h2>Image satellite</h2>
    <h4>{{ currentTime }}</h4>
    <v-card  elevation="0" color="grey lighten-5">
      <v-img style="max-height:70vh" cover  @error="imageError = true" :src="imageError ? 'https://via.placeholder.com/1054X745?text=L\'image demandé n\'est pas disponible':satSrc()" />
      <v-card-text class="px-0">
        <!-- <v-slider
          :min="-ticks.length + 1"
          v-model="currentOffset"
          thumb-label="always"
          :max="0"
        >
          <template v-slot:thumb-label="{ value }">
            {{ moment().add(value, "days").format("ddd DD MMM") }}
          </template>
        </v-slider> -->

        <vue-horizontal-timeline-slider :hidetick="true" :timestamps="ticks" v-model="selectedTs" :selectedtick="ticks[ticks.length - 1]"/>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import moment from "moment";
import VueHorizontalTimelineSlider from '@/components/VueHorizontalTimelineSlider.vue';
export default {
  components:{
    VueHorizontalTimelineSlider
  },
  computed: {
    ticks() {
      let ticks = [];
      for (var i = -72; i < -3; i++) {
        ticks.push(moment().add(i, "hours").set('minutes', 0).unix() * 1000);
      }
      // ticks = ticks.reverse();
      return ticks;
    },
    
    currentTime() {
      let time = moment().add(this.currentOffset, "hours").format("DD MMM YYYY");
      return time;
    },
  },
  methods:{
    satSrc() {
      
      return `https://sat.previmeteo.com/meteosat/image_satellite_2019.php?decalage=${moment(this.ticks[this.currentOffset]).format('YYYYMMDDHHmm')}`;
    }
  },
  data: () => ({
    currentOffset: 0,
    moment: moment,
    selectedTs:null,
    imageError:false,
  }),
  watch:{
    selectedTs(){
      this.currentOffset = this.ticks.findIndex(map=>map == this.selectedTs)
      this.imageError = false;
      
    }
  }
};
</script>

<style>
</style>